<div class="quarterly-matrix sp-card sp-p-2" [ngClass]="customClass">
  <!-- Q1 -->
  <div
    class="q-card"
    [ngClass]="{
      'active': isQuarterActive(1),
      'inactive': !isQuarterActive(1)
    }"
    (click)="onSelectQuarter(1)"
  >
    <div class="q-header">
      <span class="q-title">Q1</span>
      <span class="q-status" *ngIf="getQuarterItem(1)?.current == 1">Active</span>
    </div>
    <p class="q-amount">{{ getQuarterAmount(1) | divide }}</p>
    <p class="q-subtext">{{ getQuarterCount(1) }} {{ unitLabel }}</p>
  </div>

  <!-- Q2 -->
  <div
    class="q-card"
    [ngClass]="{
      'active': isQuarterActive(2),
      'inactive': !isQuarterActive(2)
    }"
    (click)="onSelectQuarter(2)"
  >
    <div class="q-header">
      <span class="q-title">Q2</span>
      <span class="q-status" *ngIf="getQuarterItem(2)?.current == 2">Active</span>
    </div>
    <p class="q-amount">{{ getQuarterAmount(2) | divide }}</p>
    <p class="q-subtext">{{ getQuarterCount(2) }} {{ unitLabel }}</p>
  </div>

  <!-- Q3 -->
  <div
    class="q-card"
    [ngClass]="{
      'active': isQuarterActive(3),
      'inactive': !isQuarterActive(3)
    }"
    (click)="onSelectQuarter(3)"
  >
    <div class="q-header">
      <span class="q-title">Q3</span>
      <span class="q-status" *ngIf="getQuarterItem(3)?.current == 3">Active</span>
    </div>
    <p class="q-amount">{{ getQuarterAmount(3) | divide }}</p>
    <p class="q-subtext">{{ getQuarterCount(3) }} {{ unitLabel }}</p>
  </div>

  <!-- Q4 -->
  <div
    class="q-card"
    [ngClass]="{
      'active': isQuarterActive(4),
      'inactive': !isQuarterActive(4)
    }"
    (click)="onSelectQuarter(4)"
  >
    <div class="q-header">
      <span class="q-title">Q4</span>
      <span class="q-status" *ngIf="getQuarterItem(4)?.current == 4">Active</span>
    </div>
    <p class="q-amount">{{ getQuarterAmount(4) | divide }}</p>
    <p class="q-subtext">{{ getQuarterCount(4) }} {{ unitLabel }}</p>
  </div>
</div>
